export const SpinnerActionTypes = {
  SET_SPINNER: "SET_SPINNER",
};
